export enum PaymentMethodType {
  stripeCard = 'stripe-card',
  stripeSetupCard = 'stripe-setup-card',
  stripePaymentSheet = 'stripe-payment-sheet',
  stripeSetupPaymentSheet = 'stripe-setup-payment-sheet',
  externalSepaDebit = 'external-sepa-debit',
  cash = 'cash',
}
